/* tslint:disable */
/* eslint-disable */
/* @relayHash 27209166d794e65c8d18859356206175 */

import { ConcreteRequest } from "relay-runtime";
export type queries_HistoricalDelegatesQueryVariables = {
    courseID: number;
    expiringInDays?: number | null;
    offset: number;
    limit: number;
};
export type queries_HistoricalDelegatesQueryResponse = {
    readonly historicalCourseTakers: {
        readonly edges: ReadonlyArray<{
            readonly user: {
                readonly firstName: string;
                readonly lastName: string;
                readonly email: string | null;
            };
            readonly certificateURL: string | null;
            readonly expiryDate: string | null;
        } | null> | null;
        readonly pageInfo: {
            readonly total: number;
            readonly limit: number;
            readonly offset: number;
            readonly given: number;
        } | null;
    } | null;
};
export type queries_HistoricalDelegatesQuery = {
    readonly response: queries_HistoricalDelegatesQueryResponse;
    readonly variables: queries_HistoricalDelegatesQueryVariables;
};



/*
query queries_HistoricalDelegatesQuery(
  $courseID: Int!
  $expiringInDays: Int
  $offset: Int!
  $limit: Int!
) {
  historicalCourseTakers(page: {limit: $limit, offset: $offset}, filter: {courseID: $courseID, expiringInDays: $expiringInDays}) {
    edges {
      user {
        firstName
        lastName
        email
      }
      certificateURL
      expiryDate
    }
    pageInfo {
      total
      limit
      offset
      given
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "courseID",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "expiringInDays",
            "type": "Int",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "offset",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "limit",
            "type": "Int!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "historicalCourseTakers",
            "storageKey": null,
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "filter",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "courseID",
                            "variableName": "courseID"
                        },
                        {
                            "kind": "Variable",
                            "name": "expiringInDays",
                            "variableName": "expiringInDays"
                        }
                    ]
                },
                {
                    "kind": "ObjectValue",
                    "name": "page",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit"
                        },
                        {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset"
                        }
                    ]
                }
            ],
            "concreteType": "TakersPage",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TakerResponse",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "firstName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "lastName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "certificateURL",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "expiryDate",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pageInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "total",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "limit",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "offset",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "given",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "queries_HistoricalDelegatesQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "queries_HistoricalDelegatesQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "queries_HistoricalDelegatesQuery",
            "id": null,
            "text": "query queries_HistoricalDelegatesQuery(\n  $courseID: Int!\n  $expiringInDays: Int\n  $offset: Int!\n  $limit: Int!\n) {\n  historicalCourseTakers(page: {limit: $limit, offset: $offset}, filter: {courseID: $courseID, expiringInDays: $expiringInDays}) {\n    edges {\n      user {\n        firstName\n        lastName\n        email\n      }\n      certificateURL\n      expiryDate\n    }\n    pageInfo {\n      total\n      limit\n      offset\n      given\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'f4039a631770e16b6afbc6c9a1ecce12';
export default node;
